"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCancellationPriceOutputWidget = void 0;
var React = require("react");
var mtaPriceOutputWidget_1 = require("../mtaPriceOutputWidget");
var CarCancellationPriceOutputWidget = /** @class */ (function (_super) {
    __extends(CarCancellationPriceOutputWidget, _super);
    function CarCancellationPriceOutputWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarCancellationPriceOutputWidget.prototype.render = function () {
        if (this.props.interaction.factors && this.props.interaction.factors.returnPremium) {
            return (React.createElement("div", { className: "premium-output" },
                React.createElement("div", { className: "top-section" },
                    React.createElement("div", { className: "premium-info" }, this.showRefundPremium())),
                React.createElement("div", { className: "bottom-section" }, this.renderCancellationDisclaimer())));
        }
        else {
            return (React.createElement("div", null,
                React.createElement("div", { className: "journey-bg" },
                    React.createElement("div", null,
                        React.createElement("img", { className: "waves", src: "/img/Flow-waves.svg", alt: "Journey background waves" }),
                        React.createElement("img", { className: "clouds", src: "/img/Flow-clouds.svg", alt: "Journey background clouds" }))),
                React.createElement("div", { className: "panel gutter-sides pt-4" }, this.renderCancellationDisclaimer())));
        }
    };
    CarCancellationPriceOutputWidget.prototype.renderCancellationDisclaimer = function () {
        var _a = this.props.interaction.vehicles[0], make = _a.make, model = _a.model, registrationNumber = _a.registrationNumber;
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "px-0 mt-0 mb-3" }, "Cancel subscription for ".concat(make, ", ").concat(model, " (").concat(registrationNumber, ")")),
            React.createElement("p", null, "The good news, you can always come back at any time."),
            React.createElement("p", null, "If you cancel your subscription you will no longer be covered. You have a legal obligation to ensure your car is insured at all times, so you will need to have alternative cover for your car(s).")));
    };
    return CarCancellationPriceOutputWidget;
}(mtaPriceOutputWidget_1.MtaPriceOutputWidget));
exports.CarCancellationPriceOutputWidget = CarCancellationPriceOutputWidget;
//# sourceMappingURL=CarCancellationPriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/CarCancellationPriceOutputWidget.js
// module id = 2592
// module chunks = 0